function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import React from 'react';
import cx from 'classnames';
import PropTypes from 'prop-types';
import Button from '../Button';
import Logo from '../Logo';
import NavDrawerGroup from './NavDrawerGroup';
import NavDrawerItem from './NavDrawerItem';
import NavDrawerSubItem from './NavDrawerSubItem';
import componentGenerator from '../utils/componentGenerator';

var NavDrawerContainer = /*#__PURE__*/function (_React$Component) {
  _inherits(NavDrawerContainer, _React$Component);

  var _super = _createSuper(NavDrawerContainer);

  function NavDrawerContainer() {
    var _this;

    _classCallCheck(this, NavDrawerContainer);

    _this = _super.call(this);

    _defineProperty(_assertThisInitialized(_this), "handleItemSelected", function (index, parentIndex, name, grandParentIndex) {
      _this.setState({
        activeArray: [grandParentIndex, parentIndex, index],
        name: name
      });
    });

    _defineProperty(_assertThisInitialized(_this), "handleActiveState", function (index, parentIndex, name) {
      var activeArray = _this.state.activeArray;
      return parentIndex === activeArray[1] && index === activeArray[2] && // eslint-disable-next-line react/destructuring-assignment
      name === _this.state.name;
    });

    _this.state = {
      activeArray: []
    };
    return _this;
  }

  _createClass(NavDrawerContainer, [{
    key: "render",
    value: function render() {
      var _this2 = this;

      var _this$props = this.props,
          children = _this$props.children,
          data = _this$props.data,
          open = _this$props.open,
          onToggle = _this$props.onToggle,
          closeBtnRefCallback = _this$props.closeBtnRefCallback,
          expandedIndex = _this$props.expandedIndex,
          handleExpandedIndex = _this$props.handleExpandedIndex,
          NavDrawerContentComponent = _this$props.NavDrawerContentComponent,
          logo = _this$props.logo;
      var activeArray = this.state.activeArray;

      var navComponentSelector = function navComponentSelector(level) {
        switch (level) {
          case 0:
            return function (props) {
              return /*#__PURE__*/React.createElement(NavDrawerGroup, _extends({}, props, {
                isAccordion: props.children.length
              }));
            };

          case 1:
            return function (props) {
              return /*#__PURE__*/React.createElement(NavDrawerItem, _extends({}, props, {
                open: open,
                isAccordion: props.children.length > 0,
                onToggle: onToggle,
                onItemClick: function onItemClick() {
                  if (props.index !== expandedIndex) {
                    handleExpandedIndex(props.index);
                  }
                }
              }, props.index === expandedIndex && {
                expanded: true
              }));
            };

          default:
            return function (props) {
              return /*#__PURE__*/React.createElement(NavDrawerSubItem, _extends({
                onToggle: onToggle,
                onItemClick: function onItemClick() {
                  _this2.handleItemSelected(props.index, props.parentIndex, props.name, props.grandParentIndex);
                }
              }, props, {
                active: _this2.handleActiveState(props.index, props.parentIndex, props.name),
                isAccordion: props.children.length > 0,
                expanded: activeArray[0] === props.parentIndex && activeArray[1] === props.index
              }));
            };
        }
      };

      var ntClass = cx({
        navdrawer: true,
        'navdrawer--active': open,
        'navdrawer--closed': !open
      });
      var ntOverlayClass = cx({
        navdrawer__overlay: true,
        'navdrawer__overlay--active': open,
        'navdrawer__overlay--closed': !open
      });
      return /*#__PURE__*/React.createElement("div", {
        className: "navdrawer__container"
      }, /*#__PURE__*/React.createElement("div", {
        className: ntClass
      }, /*#__PURE__*/React.createElement(Button, _extends({
        size: "medium",
        onClick: onToggle,
        className: "position-absolute top-md left-md appbar__navIcon",
        kind: "borderless",
        iconName: "close",
        icon: "only"
      }, closeBtnRefCallback && {
        ref: closeBtnRefCallback
      }, open === true && {
        tabIndex: 0
      }, open === false && {
        tabIndex: -1
      }, {
        includeRef: true
      })), /*#__PURE__*/React.createElement("div", {
        className: "margintop-xxxl marginbottom-sm textalign-center"
      }, logo ? logo() : /*#__PURE__*/React.createElement(Logo, {
        width: "140"
      })), children ? /*#__PURE__*/React.createElement("div", null, children) : componentGenerator(data, navComponentSelector), NavDrawerContentComponent && NavDrawerContentComponent()), /*#__PURE__*/React.createElement("div", {
        className: ntOverlayClass,
        onClick: onToggle,
        onKeyDown: function onKeyDown(e) {
          return e.key === 'Enter' ? onToggle() : null;
        },
        role: "presentation"
      }));
    }
  }]);

  return NavDrawerContainer;
}(React.Component);

_defineProperty(NavDrawerContainer, "propTypes", {
  children: PropTypes.node,
  data: PropTypes.oneOfType([PropTypes.object, PropTypes.array]),
  open: PropTypes.bool,
  onToggle: PropTypes.func,
  closeBtnRefCallback: PropTypes.func,
  handleExpandedIndex: PropTypes.func,

  /** Function to add additional component on mobile NavDrawer */
  NavDrawerContentComponent: PropTypes.func,

  /** Custom logo */
  logo: PropTypes.func,
  expandedIndex: PropTypes.number
});

NavDrawerContainer.__docgenInfo = {
  "description": "",
  "methods": [{
    "name": "handleItemSelected",
    "docblock": null,
    "modifiers": [],
    "params": [{
      "name": "index",
      "type": null
    }, {
      "name": "parentIndex",
      "type": null
    }, {
      "name": "name",
      "type": null
    }, {
      "name": "grandParentIndex",
      "type": null
    }],
    "returns": null
  }, {
    "name": "handleActiveState",
    "docblock": null,
    "modifiers": [],
    "params": [{
      "name": "index",
      "type": null
    }, {
      "name": "parentIndex",
      "type": null
    }, {
      "name": "name",
      "type": null
    }],
    "returns": null
  }],
  "displayName": "NavDrawerContainer",
  "props": {
    "children": {
      "type": {
        "name": "node"
      },
      "required": false,
      "description": ""
    },
    "data": {
      "type": {
        "name": "union",
        "value": [{
          "name": "object"
        }, {
          "name": "array"
        }]
      },
      "required": false,
      "description": ""
    },
    "open": {
      "type": {
        "name": "bool"
      },
      "required": false,
      "description": ""
    },
    "onToggle": {
      "type": {
        "name": "func"
      },
      "required": false,
      "description": ""
    },
    "closeBtnRefCallback": {
      "type": {
        "name": "func"
      },
      "required": false,
      "description": ""
    },
    "handleExpandedIndex": {
      "type": {
        "name": "func"
      },
      "required": false,
      "description": ""
    },
    "NavDrawerContentComponent": {
      "type": {
        "name": "func"
      },
      "required": false,
      "description": "Function to add additional component on mobile NavDrawer"
    },
    "logo": {
      "type": {
        "name": "func"
      },
      "required": false,
      "description": "Custom logo"
    },
    "expandedIndex": {
      "type": {
        "name": "number"
      },
      "required": false,
      "description": ""
    }
  }
};
export default NavDrawerContainer;